module.exports = __webpack_public_path__ + "img/IntroTree.a8c07727.svg";